import { LandingNavbar } from "@/components/landing/LandingNavbar";
import { HeroSection } from "@/components/landing/HeroSection";
import { LazySection } from "@/components/landing/LazySection";

// Define section configurations for optimal lazy loading
const sections = [
  {
    key: 'dashboard-preview',
    factory: () => import("@/components/landing/DashboardPreviewSection").then(m => ({ default: m.DashboardPreviewSection })),
    minHeight: '400px',
    rootMargin: '500px', // Load earlier since it's right after hero
  },
  {
    key: 'report-preview',
    factory: () => import("@/components/landing/ReportPreviewSection").then(m => ({ default: m.ReportPreviewSection })),
    minHeight: '500px',
    rootMargin: '400px',
  },
  {
    key: 'value-proposition',
    factory: () => import("@/components/landing/ValuePropositionSection").then(m => ({ default: m.ValuePropositionSection })),
    minHeight: '320px',
    rootMargin: '400px',
  },
  {
    key: 'process',
    factory: () => import("@/components/landing/ProcessSection").then(m => ({ default: m.ProcessSection })),
    minHeight: '600px',
    rootMargin: '300px',
  },
  {
    key: 'features',
    factory: () => import("@/components/landing/FeaturesSection").then(m => ({ default: m.FeaturesSection })),
    minHeight: '700px',
    rootMargin: '300px',
  },
  {
    key: 'outcome',
    factory: () => import("@/components/landing/OutcomeSection").then(m => ({ default: m.OutcomeSection })),
    minHeight: '600px',
    rootMargin: '250px',
  },
  {
    key: 'roi',
    factory: () => import("@/components/landing/ROISection").then(m => ({ default: m.ROISection })),
    minHeight: '800px',
    rootMargin: '250px',
  },
  {
    key: 'mission',
    factory: () => import("@/components/landing/MissionSection").then(m => ({ default: m.MissionSection })),
    minHeight: '300px',
    rootMargin: '200px',
  },
  {
    key: 'trust',
    factory: () => import("@/components/landing/TrustSection").then(m => ({ default: m.TrustSection })),
    minHeight: '150px',
    rootMargin: '200px',
  },
  {
    key: 'faq',
    factory: () => import("@/components/landing/FAQSection").then(m => ({ default: m.FAQSection })),
    minHeight: '500px',
    rootMargin: '200px',
  },
  {
    key: 'final-cta',
    factory: () => import("@/components/landing/FinalCTASection").then(m => ({ default: m.FinalCTASection })),
    minHeight: '400px',
    rootMargin: '200px',
  },
  {
    key: 'footer',
    factory: () => import("@/components/layout/PublicFooter").then(m => ({ default: m.PublicFooter })),
    minHeight: '200px',
    rootMargin: '150px',
  },
];

const Index = () => {
  return (
    <div className="min-h-screen bg-background scroll-smooth animate-fade-in">
      <LandingNavbar />
      <HeroSection />
      
      {/* Lazy-loaded sections with individual Suspense boundaries */}
      {sections.map((section) => (
        <LazySection
          key={section.key}
          sectionKey={section.key}
          factory={section.factory}
          minHeight={section.minHeight}
          rootMargin={section.rootMargin}
        />
      ))}
    </div>
  );
};

export default Index;
